'use client';

import { useState } from 'react';
import Link from 'next/link';

const faqs = [
  {
    id: 1,
    question: 'What is Female Fitness Finder?',
    answer: 'Female Fitness Finder is the UK\'s leading directory for women-only gyms, fitness studios, and female personal trainers. We help women discover safe, comfortable, and welcoming fitness spaces where they can achieve their health goals without judgment or intimidation.',
  },
  {
    id: 2,
    question: 'Is it really only for women?',
    answer: 'Yes! We specifically list women-only gyms, female-led fitness studios, and female personal trainers. Our platform is designed to create a supportive environment where women can focus on their fitness journey with confidence and comfort.',
  },
  {
    id: 3,
    question: 'How do you verify the gyms and trainers?',
    answer: 'We have a thorough verification process that includes checking business licenses, visiting facilities, reviewing customer feedback, and confirming that listed spaces genuinely provide women-only or women-focused environments. We regularly update our listings to ensure accuracy.',
  },
  {
    id: 4,
    question: 'How do I find a gym near me?',
    answer: 'Simply enter your city, postcode, or location in our search bar. You can then filter results by activities (yoga, Pilates, HIIT, etc.), amenities (pool, sauna, childcare), and distance to find the perfect fitness space near you.',
  },
  {
    id: 5,
    question: 'Do I need to pay to use the directory?',
    answer: 'No, our directory is completely free for users to browse and search. You can view gym details, read reviews, and contact facilities at no cost. Some gyms may have their own membership fees, but accessing our platform is always free.',
  },
  {
    id: 6,
    question: 'How do I leave a review for a gym I\'ve visited?',
    answer: 'After visiting a listed gym or training with a personal trainer, you can leave a review by clicking on their listing and selecting "Write a Review." Your honest feedback helps other women make informed decisions about their fitness journey.',
  },
];

const FAQ = () => {
  const [openId, setOpenId] = useState<number | null>(1);

  const toggleFaq = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="py-20 bg-[#f5f2f0]">
      <div className="max-w-[800px] mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-sm font-medium text-[#8a7490] tracking-wide uppercase text-center mb-3">
          FAQ
        </p>
        <h2 className="text-3xl md:text-4xl font-bold text-[#2b262e] text-center mb-12">
          Frequently Asked Questions
        </h2>

        <div className="space-y-3">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className={`rounded-[16px] overflow-hidden transition-colors ${
                openId === faq.id ? 'bg-[#8a7490]' : 'bg-white'
              }`}
            >
              <button
                onClick={() => toggleFaq(faq.id)}
                className="w-full flex items-center justify-between p-6 text-left"
              >
                <div className="flex items-center gap-4">
                  <span className={`text-sm font-medium ${openId === faq.id ? 'text-white/80' : 'text-[#8a7490]'}`}>
                    {String(faq.id).padStart(2, '0')}
                  </span>
                  <span className={`font-medium ${openId === faq.id ? 'text-white' : 'text-[#2b262e]'}`}>
                    {faq.question}
                  </span>
                </div>
                <svg
                  className={`w-5 h-5 flex-shrink-0 transition-transform ${
                    openId === faq.id ? 'text-white rotate-45' : 'text-[#6e6672]'
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                </svg>
              </button>
              {openId === faq.id && (
                <div className="px-6 pb-6">
                  <p className="text-white/90 leading-relaxed pl-10">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            href="/faq"
            className="inline-block px-8 py-3 bg-[#8a7490] text-white font-medium rounded-xl hover:bg-[#7a647d] transition-colors"
          >
            Read More FAQs
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
